import axiosInstance from "../../../helpers/api";

export const getVideosByChapterID = (id) => {
  return axiosInstance.get(`/students/videos/${id}`);
};

export const getVideoByID = (id) => {
  return axiosInstance.get(`/students/videos/show/${id}`);
};

export const getOtp = (id) => {
  return axiosInstance.get(`/students/videos/otp/${id}`);
};

export const updateSeenCount = (body) => {
  return axiosInstance.put(`/students/user_videos/${body?.video_id}`);
};

export const createSeenCount = (body) => {
  return axiosInstance.post(`/students/user_videos`, body);
};
export const addVoucher = (body) => {
  return axiosInstance.post(`/students/video_requests/submitVoucher`, body);
};
export const moreVideoViews = (body) => {
  return axiosInstance.post(`/students/video_requests`, body);
};

export const videoData = (body) => {
  return axiosInstance.post(`/students/user_videos/add_watched_time`, body);
};

export const getLiveVideo = () => {
  return axiosInstance.get(`/students/live_videos`);
};

export const setLiveVideoSeen = (id) => {
  return axiosInstance.post(`/students/live_videos`, {
    zoom_id: id,
  });
};
